// These are the grid parameters for the WaveInsightsGraph component,

import { useMinWidthTablet } from 'hooks/useMediaQueries';

export type RewindGraphGridParams = {
  gridTemplateRows: string;
  gridTemplateColumns: string;
  chartAreaRows: string;
  chartAreaColumns: string;
  chartStartColumn: number;
  chartAreaColumnsLength: number;
  heightAxisColumn: string;
  timeAxisTicksRow: number;
  timeAxisLabelsRow: number;
  baseHeight: number;
  fullHeight: number;
  errorHeight: number;
};

export const useRewindGraphGridParams = ({
  chartAreaColumnsLength,
  isThumbnail,
  padding = '5%',
  renderDataRow,
}: {
  chartAreaColumnsLength: number;
  isThumbnail?: boolean;
  padding?: string;
  renderDataRow?: boolean;
}): RewindGraphGridParams => {
  const isMinWidthTablet = useMinWidthTablet();
  const fullHeight = !isMinWidthTablet && isThumbnail ? 75 : 115;

  return {
    gridTemplateRows: `${renderDataRow ? 1 : 0}fr 8px 15px`,
    gridTemplateColumns: `${padding} repeat(${chartAreaColumnsLength}, 1fr) ${padding}`,
    chartAreaRows: '1',
    chartAreaColumns: `2 / ${chartAreaColumnsLength + 2}`,
    chartStartColumn: 2,
    chartAreaColumnsLength,
    heightAxisColumn: '1',
    timeAxisTicksRow: 2,
    timeAxisLabelsRow: 3,
    baseHeight: 8 + 15,
    fullHeight,
    errorHeight: 15,
  };
};
